import type { TourSettings } from '@carboncopyco/types';
import rgbHex from 'rgb-hex';
import squaresBackgroundImage from '../assets/squaresBackgroundImage';

export const DEFAULT_BACKGROUND_COLOR = {
  r: 249,
  g: 249,
  b: 249,
  a: 1,
};

export const getTourBackgroundStyles = ({
  tourSettings,
  isEditor = false,
  fileServiceApiToken,
}: {
  tourSettings: TourSettings;
  isEditor?: boolean;
  fileServiceApiToken: string;
}) => {
  if (
    !tourSettings?.background?.backgroundType ||
    tourSettings?.background?.backgroundType === 'color'
  ) {
    const color = tourSettings?.background?.color || DEFAULT_BACKGROUND_COLOR;
    return {
      backgroundColor: `#${rgbHex(color.r, color.g, color.b, color.a)}`,
    };
  }

  const imageUrl = isEditor
    ? tourSettings?.background?.image || squaresBackgroundImage
    : tourSettings?.background?.image;

  return {
    backgroundImage: `url(${imageUrl}?token=${fileServiceApiToken})`,
  };
};
